// context/FavoritesContext.js
import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import api from '../api/axiosInstance';


export const FavoritesContext = createContext();

export const FavoritesProvider = ({ children }) => {
  const [favorites, setFavorites] = useState([]);
  const [showPopup, setShowPopup] = useState(false);

  // Cargar favoritos al montar, si hay user
  useEffect(() => {
    const storedUserId = localStorage.getItem("userId");
    if (storedUserId) {
      loadFavorites(storedUserId);
    }
  }, []);

  // Carga los favoritos desde tu API
  const loadFavorites = async (userId) => {
    try {
      const { data } = await api.get(`/favorites/${userId}`);
      setFavorites(data || []);
    } catch (error) {
      console.error("Error al cargar favoritos:", error);
    }
  };

  // Agregar a favoritos
  const addToFavorites = async (product) => {
    // Verifica user
    const userId = localStorage.getItem("userId");
    if (!userId) {
      setShowPopup(true); // abre popup igual que carrito
      return;
    }

    // Si ya está en favoritos, no hace nada
    const exists = favorites.some((fav) => fav.id === product.id);
    if (exists) return;

    try {
      // Llama a tu endpoint /api/favorites
      await api.post("/favorites/add", {
        userId,
        productId: product.id,
      });
      // Actualiza estado
      setFavorites((prev) => [...prev, product]);
    } catch (error) {
      console.error("Error al agregar a favoritos:", error);
    }
  };

  // Quitar de favoritos
  const removeFromFavorites = async (productId) => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      setShowPopup(true);
      return;
    }

    try {
      await api.delete(`/favorites/remove/${userId}/${productId}`);
      setFavorites((prev) => prev.filter((item) => item.id !== productId));
    } catch (error) {
      console.error("Error al quitar de favoritos:", error);
    }
  };

  return (
    <FavoritesContext.Provider
      value={{
        favorites,
        addToFavorites,
        removeFromFavorites,
        showPopup,
        setShowPopup,
      }}
    >
      {children}
    </FavoritesContext.Provider>
  );
};
